class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    const summary = this.mainDetailsToggle.querySelector('summary');

    summary.addEventListener('click', (event) => {
      if (this.openedByHover && event.detail > 0) {
        event.preventDefault();
        this.openedByHover = false;
      }
    });

    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !this.hoverMedia.matches) return;

      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
      this.openedByHover = !this.mainDetailsToggle.open;
      this.mainDetailsToggle.open = true;
    });

    this.header.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse' && this.hoverMedia.matches && !this.content.contains(document.activeElement)) {
        this.close();
        this.openedByHover = false;
      }
    });

    if (this.classList.contains('header-menu--linked')) {
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
